import * as React from 'react'

const Phone = ({ className = 'svg-white' }: { className?: string }) => (
  <svg
    className={'icon ' + className}
    width='13'
    height='16'
    viewBox='0 0 13 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.42172 9.30603L0.861725 12.008C2.62651 13.0269 3.48617 13.5232 5.75883 12.526C7.30533 11.8474 7.95046 10.619 8.87486 9.12886C9.83531 7.58058 10.8645 5.68271 10.5088 4.29874C9.98615 2.26491 9.12651 1.76859 7.36172 0.749696L5.80172 3.4517C7.96679 4.7017 7.52479 5.46726 6.27679 7.62886C5.02879 9.79046 4.58679 10.556 2.42172 9.30603Z'
      stroke='white'
      strokeOpacity='0.5'
    />
  </svg>
)

export default Phone



// WEBPACK FOOTER //
// ./src/components/icons/auth/Phone.tsx